import { mainApi } from "../../../../api";

export const subscriptionOptionsQuery = () => ({
    queryKey: ["subscriptionOptions"],
    queryFn: async () => mainApi.get("subscription_options"),
    cacheTime: 1000,
    staleTime: 1000,
});
